import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {KeycloakApplicationRolesEnum} from '@core/modules/rest/user/enums/keycloak-application-roles.enum';
import {CreateUserPopupModel} from './model/create-user-popup.model';
import {TranslateService} from '@ngx-translate/core';
import * as EmailValidator from 'email-validator';
import {UserInfoComponent} from './user-info/user-info.component';

@Component({
    selector: 'app-create-user-popup',
    templateUrl: './create-user-popup.component.html',
    styleUrls: ['./create-user-popup.component.scss']
})
export class CreateUserPopupComponent implements OnInit {

    @Input() emailExists: boolean;
    @Output() closeDialogEvent: EventEmitter<void> = new EventEmitter<void>();
    @Output() createUserEvent: EventEmitter<CreateUserPopupModel> = new EventEmitter();
    @Output() resetEmailExistValidationEvent: EventEmitter<void> = new EventEmitter();
    @ViewChild(UserInfoComponent)
    userInfoComponent: UserInfoComponent;

    createButtonDisabled = true;
    formValid = false;

    showSpecialCharacterWarning = false;
    selectedRoles: KeycloakApplicationRolesEnum[] = [];

    title: string;

    constructor(private translateService: TranslateService) {
    }

    private static isNameValid(name: string): boolean {
        if (name) {
            return name.length >= 3;
        }
        return false;
    }

    private static isEmailValid(email: string): boolean {
        if (email) {
            return EmailValidator.validate(email);
        }

        return false;
    }

    ngOnInit(): void {
        this.title = this.translateService.instant('GENERAL.CREATE_NEW_USER');
    }

    toggleRole(role: KeycloakApplicationRolesEnum): void {
        if (this.selectedRoles.includes(role)) {
            const index = this.selectedRoles.indexOf(role);
            this.selectedRoles.splice(index, 1);
        } else {
            this.selectedRoles.push(role);
        }
        if (this.selectedRoles.length === 0) {
            this.createButtonDisabled = true;
        } else {
            this.createButtonDisabled = this.formValid ? false : true;
        }
    }

    onKeyUp(event: any, role: KeycloakApplicationRolesEnum): void {
        if (event.key === 'Enter' || event.code === 'Space') {
            this.toggleRole(role);
        }
    }

    submit(): void {
        this.userInfoComponent.saveUser();
    }

    createUser(createUser: CreateUserPopupModel): void {
        this.createUserEvent.emit(createUser);
    }

    validateForm(event: any): void {
        const emailOK = CreateUserPopupComponent.isEmailValid(event.email);
        const nameOK = CreateUserPopupComponent.isNameValid(event.name);
        this.formValid = !((!event.email && !event.name) || !emailOK || !nameOK);
        this.createButtonDisabled = !this.formValid || this.selectedRoles.length === 0;
    }
}
